import * as classnames from 'classnames'
import * as React from 'react'

import * as styles from './itemThumbnailCarousel.module.css'

const ItemThumbnailCarousel = ({
  children,
  justifyContent,
  itemWidth = 'auto'
}: {
  children: any
  justifyContent?: 'center' | 'flex-end'
  itemWidth?: number | 'auto'
}) => {
  const listItems = React.Children.map(children, child => {
    return (
      <ItemThumbnailCarouselElement itemWidth={itemWidth}>
        {child}
      </ItemThumbnailCarouselElement>
    )
  })

  const itemListContainerClassNames = classnames(styles.itemListContainer, {
    [styles.justifyCenter]: justifyContent === 'center',
    [styles.justifyFlexEnd]: justifyContent === 'flex-end'
  })

  return (
    <div className={styles.itemListWrapper}>
      <ul className={itemListContainerClassNames}>
        {listItems.length > 0 ? (
          listItems
        ) : (
          <ItemThumbnailCarouselElement itemWidth="auto">
            No items currently available
          </ItemThumbnailCarouselElement>
        )}
      </ul>
    </div>
  )
}

const ItemThumbnailCarouselElement = ({
  children,
  itemWidth
}: {
  children: React.ReactNode
  itemWidth?: number | 'auto'
}) => (
  <li className={styles.itemList} style={{ width: itemWidth }}>
    {children}
  </li>
)

export default ItemThumbnailCarousel
